module.exports = __webpack_public_path__ + "img/1.2.4bc3dfab.svg";